export const ROUTES = (() => {
  return {
    RATES: `${process.env.REACT_APP_API_HOST}/v1/rates`,
    FEES: `${process.env.REACT_APP_API_HOST}/v1/fees`,
  }
})()
